<template>
	<el-dialog
		:show-close="isShowClose"
		:title="title"
		:top="top"
		:visible.sync="isShowDialog"
		:width="width"
		append-to-body
		center
		destroy-on-close
		@close="onClose">
		<div v-if="formOptionNum === '1'" class="u-flex">
			<el-upload
				:auto-upload="false"
				:on-change="onImportData"
				:show-file-list="false"
				accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
				action="">
				<el-button class="el-icon-upload2" type="primary">批量上传</el-button>
			</el-upload>
			<el-button class="u-m-l-20" icon="el-icon-download" @click="onDownloadExample">下载模板</el-button>
		</div>
		<div style="padding-bottom: 10px">
			<slot name="form_top"></slot>
		</div>
		<avue-crud
			ref="crud_content"
			:class="baseClass"
			:data="getFormDataPageList"
			:option="optionData"
			:page.sync="pages"
			:search.sync="searchParams"
			:tableLoading="isFormLoading"
			@selection-change="onSelectionChange"
			@search-change="onSearchChange"
			@search-reset="onSearchChange"></avue-crud>

		<div style="padding-top: 10px">
			<slot :selectList="selectList" name="form_bottom"></slot>
		</div>
		<div v-if="!isForm" slot="footer">
			<el-button
				v-if="btnLeftText"
				:loading="btnLoading"
				style="margin: 0 15px"
				type="primary"
				@click.prevent.native="onClickLeft">
				{{ btnLeftText }}
			</el-button>
			<el-button v-if="btnRightText" :loading="btnLoading" style="margin: 0 15px" @click.prevent.native="onClickRight">
				{{ btnRightText }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {optionCouponChannels, optionCouponChoiceChannels} from '@/const/crud/insurance/dialog'

import {downloadLocalFile} from '@/util/util'
import _ from 'lodash'

export default {
	name: 'baseFormPageDialog',
	mixins: [],
	components: {},
	props: {
		title: {
			type: String,
			default: '提示',
		},
		isForm: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: '70%',
		},
		isShowClose: {
			type: Boolean,
			default: false,
		},
		btnLeftText: String,
		btnRightText: String,
		formDataListTemp: {
			type: Array,
		},
		formOptionNumTemp: {
			type: String,
			default: '0',
		},
		top: {
			type: String,
			default: '8vh',
		},
		baseClass: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isShowDialog: false,
			isFormLoading: false,
			//带有表格的dialog
			formOptionNum: this.formOptionNumTemp,
			optionData: {},
			formDataList: this.formDataListTemp || [],
			btnLoading: false,
			formData: {},
			fileList: [],
			//单选
			selectRowData: '',
			pages: {
				total: 0,
				currentPage: 1,
				pageSize: 10,
				pageSizes: [10],
			},
			searchParams: {},
			//选中的数据
			selectList: [],
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
		getFormDataPageList() {
			//通过formDataList 和pages 进行分页，
			let {currentPage, pageSize} = this.pages
			let startIndex = (currentPage - 1) * pageSize
			let endIndex = currentPage * pageSize
			let allData = this.deepClone(this.formDataList)
			//处理搜索
			let {name: searchName = ''} = this.searchParams
			if (searchName) {
				allData = allData.filter(({name = ''}) => name && (name === searchName || name.includes(searchName)))
			}
			this.pages.total = allData.length
			return allData.length > pageSize ? allData.slice(startIndex, endIndex) : allData
		},
	},
	watch: {
		title(valNew, valOld) {
			if (valNew && valNew !== valOld) {
				this.title = valNew
			}
		},
		formOptionNumTemp(valNew, valOld) {
			//根据传递的number 获取option
			if (valNew !== valOld) {
				this.formOptionNum = valNew
				this.getOptions()
			}
		},
		formDataListTemp: {
			handler(valNew = []) {
				if (!this.validatenull(valNew)) {
					this.formDataList = this.deepClone(valNew)
					this.pages.total = this.formDataList.length
				}
			},
			deep: true,
		},
	},
	created() {},
	mounted() {
		//先获取option
		this.getOptions()
		this.onSendFileList = _.debounce(this.onSendFileList, 1000)
	},
	methods: {
		onSendFileList() {
			this.$emit('onSendFileList', this.fileList)
		},
		onClickLeft() {
			if (this.formOptionNum === '1') {
				//新增佣金券
				//校验选择的数据，是否有count 用find方法
				let tempData = this.selectList.find(({count}) => !count || count === '0')
				if (tempData) {
					this.$message.error(`请填写${tempData.name}的数量！！`)
					return
				}
				this.$emit('onClickLeft', this.selectList)
			} else {
				this.$emit('onClickLeft')
			}
			this.isShowDialog = false
		},
		onClickRight() {
			this.isShowDialog = false
			this.$emit('onClickRight')
		},
		getOptions() {
			switch (this.formOptionNum) {
				case '0':
					//佣金券查看渠道
					this.optionData = this.deepClone(optionCouponChannels)
					break
				case '1':
					//佣金券选择渠道
					this.optionData = this.deepClone(optionCouponChoiceChannels)
					//需要column
					this.findObject(this.optionData.column, 'count').change = (data) => {
						console.log('data:::------------ ', data)
						let {
							value = '0',
							row: {id = '', status = 0},
						} = data
						//判断状态status 不为1 则提示返回
						if (status !== 1) {
							this.$message.error('该渠道已停用，无法选择！')
							return
						}
						//通过渠道ID，直接改数据
						let tempIndex = this.formDataList.findIndex(({id: id1}) => id1 === id)
						if (tempIndex !== -1) {
							this.formDataList[tempIndex].count = value
						}
						//selectList
						let tempIndex1 = this.selectList.findIndex(({id: id1}) => id1 === id)
						if (tempIndex1 !== -1) {
							this.selectList[tempIndex1].count = value
						}
					}
					break
			}
		},
		//异常保单修改的时候，需要传入金额提示
		show(dataList = [], formOptionNum = '') {
			if (formOptionNum) {
				this.formOptionNum = formOptionNum
			}
			if (this.formOptionNum !== '1' || this.formDataList.length <= 0) {
				this.formDataList = dataList
				this.pages.total = this.formDataList.length
			}
			this.isShowDialog = true
		},
		onClose() {
			this.pages = {
				total: 0,
				currentPage: 1,
				pageSize: 10,
				pageSizes: [10],
			}
			this.searchParams = {}
			this.isShowDialog = false
			this.isFormLoading = false
		},
		//清空数据
		onClearData() {
			this.formDataList = []
			this.selectList = []
			this.searchParams = {}
		},
		isShow() {
			return this.isShowDialog
		},
		isShowLoading(isLoading = false) {
			this.btnLoading = isLoading
		},
		isShowFormLoading(isLoading = false) {
			this.isFormLoading = isLoading
		},
		onUploadAfter(res, done, loading) {
			this.$emit('onUploadAfter', res, done, loading)
		},
		onUploadBefore(files, done, loading) {
			this.isFormLoading = true
			this.fileList.push(files)
			//中断
			this.onSendFileList()
			loading()
		},
		onUploadError(error) {
			this.$message.error(error)
		},
		onUploadExceed(limit, files, fileList) {
			this.$message.error(`最多只能选择 ${limit} 个文件，当前共选择了 ${files.length} 个文件`)
		},
		//重置file数据
		onClearFileList() {
			this.fileList = []
		},
		//搜索
		onSearchChange(searchData = {}, done) {
			this.searchParams = searchData
			if (done) {
				done()
			}
		},
		//选择数据
		onSelectionChange(selection) {
			console.log('onSelectionChange-----', selection)
			this.selectList = selection
		},
		//处理已选择的数据
		onReadySelect(selection) {
			console.log('onReadySelect-----', selection)
			let allData = this.deepClone(this.formDataList)
			this.formDataList = []
			this.isFormLoading = true
			this.$nextTick(() => {
				setTimeout(() => {
					if (this.$refs.crud_content) {
						this.$refs.crud_content.toggleSelection(selection)
					}
				}, 100)
				setTimeout(() => {
					this.formDataList = allData
					//添加count
					this.onAddCount(selection)
					this.isFormLoading = false
				}, 300)
			})
		},
		//处理count数据
		onAddCount(selection) {
			for (let i = 0; i < selection.length; i++) {
				let {name: name1, count} = selection[i]
				let tempData = this.formDataList.find(({name}) => name === name1)
				if (tempData) {
					tempData.count = count
				}
			}
		},
		onImportData(file) {
			//清空
			this.$refs.crud_content.clearSelection()
			this.$Export
				.xlsx(file.raw)
				.then(async (result) => {
					console.log('批量导入文件内容----', result)
					let {results = []} = result || {}
					if (results.length <= 0) {
						this.$message.error('批量导入文件数据为空！')
						return
					}
					let importSuccessData = []
					let importErrorData = []
					for (let i = 0; i < results.length; i++) {
						let tempItemData = Object.values(results[i]) || []
						if (tempItemData.length > 0) {
							let [name1 = '', count = ''] = tempItemData || []
							if (!name1 || !count) {
								importErrorData.push(tempItemData[0])
								continue
							}
							name1 = name1.replace(/\s+/g, '')
							let tempIndex = this.formDataList.findIndex(({name}) => name === name1)
							if (tempIndex !== -1) {
								this.formDataList[tempIndex].count = count
								importSuccessData.push(this.formDataList[tempIndex])
							} else {
								importErrorData.push(tempItemData[0])
							}
						}
					}
					this.onReadySelect(importSuccessData)
					//导入列表
					let hint = `导入成功${importSuccessData.length}条，导入失败${importErrorData.length}条。`
					if (importErrorData.length > 0) {
						hint += `失败数据：${importErrorData.join('、')}`
					}
					this.$alert(hint, '提示', {}).then(() => {})
				})
				.catch(() => {})
				.finally(() => {})
		},
		onDownloadExample() {
			//下载模板
			downloadLocalFile('佣金券渠道模板')
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 10px 30px 10px !important;
}

::v-deep .el-upload__text {
	&::before {
		content: '将文件拖到此处，或';
	}
}

.coupon-policy {
	max-height: 72vh;
	overflow: scroll;
}
</style>
